require("../categories-content/categories-content");
require("../services-content/services-content");
require("../portfolio-content/portfolio-content");

const adminRoot = document.querySelector("[data-admin-root]");

function initAdminCategoriesContent() {
  const store = window.NMCategoriesContent;
  if (!store || !adminRoot || window.NMAdminCategoriesContent) return;

  const contentHome = document.querySelector("[data-content-home]");
  const categoriesEditor = document.querySelector('[data-content-editor="categories"]');
  const categoriesItemEditor = document.querySelector('[data-content-editor="categories-item"]');
  const aboutEditor = document.querySelector('[data-content-editor="about"]');
  const homeEditor = document.querySelector('[data-content-editor="home"]');
  const portfolioEditor = document.querySelector('[data-content-editor="portfolio"]');
  const contactsEditor = document.querySelector('[data-content-editor="contacts"]');
  const servicesEditor = document.querySelector('[data-content-editor="services"]');
  const articlesEditor = document.querySelector('[data-content-editor="articles"]');
  const articlesItemEditor = document.querySelector('[data-content-editor="articles-item"]');

  const categoriesList = document.querySelector("[data-categories-list]");
  const categoriesCount = document.querySelector("[data-categories-count]");
  const categoryCreateBtn = document.querySelector("[data-categories-create]");
  const itemBackBtn = document.querySelector("[data-categories-item-back]");
  const itemPageTitle = document.querySelector("[data-categories-item-page-title]");
  const itemPreviewLink = document.querySelector("[data-categories-item-preview]");
  const itemNote = document.querySelector("[data-categories-item-note]");

  const categoryForm = document.querySelector("[data-categories-form]");
  const categoryDeleteBtn = document.querySelector("[data-categories-delete]");
  const nextSelect = categoryForm?.elements.nextSlug;
  const overviewImageInput = document.querySelector("#categories-overview-image");
  const overviewImageData = document.querySelector("[data-categories-overview-image-data]");
  const overviewImagePreview = document.querySelector("[data-categories-overview-image-preview]");
  const overviewImageReset = document.querySelector("[data-categories-overview-image-reset]");
  const cardImageInput = document.querySelector("#categories-card-image");
  const cardImageData = document.querySelector("[data-categories-image-data]");
  const cardImagePreview = document.querySelector("[data-categories-image-preview]");
  const cardImageReset = document.querySelector("[data-categories-image-reset]");

  const pointsList = document.querySelector("[data-categories-points-list]");
  const pointCreateBtn = document.querySelector("[data-categories-point-create]");
  const pointModal = document.querySelector("[data-categories-point-modal]");
  const pointForm = document.querySelector("[data-categories-point-form]");
  const pointFormTitle = document.querySelector("[data-categories-point-form-title]");

  let draftCategory = null;
  let editingPointId = null;

  function hideOtherEditors() {
    if (contentHome) contentHome.hidden = true;
    if (aboutEditor) aboutEditor.hidden = true;
    if (homeEditor) homeEditor.hidden = true;
    if (portfolioEditor) portfolioEditor.hidden = true;
    if (contactsEditor) contactsEditor.hidden = true;
    if (servicesEditor) servicesEditor.hidden = true;
    if (articlesEditor) articlesEditor.hidden = true;
    if (articlesItemEditor) articlesItemEditor.hidden = true;
    const faqEditor = document.querySelector('[data-content-editor="faq"]');
    if (faqEditor) faqEditor.hidden = true;
  }

  function updateOverviewPreview(src) {
    if (!overviewImagePreview) return;
    const img = overviewImagePreview.querySelector("img");
    if (!src) {
      overviewImagePreview.hidden = true;
      if (img) img.src = "";
      return;
    }
    if (img) img.src = src;
    overviewImagePreview.hidden = false;
  }

  function isDefaultOverviewImage(src) {
    const value = String(src || "").trim();
    if (!value) return true;
    return value === store.DEFAULT_OVERVIEW_IMAGE;
  }

  function clearCategoryErrors() {
    categoryForm?.querySelectorAll("[data-categories-field]").forEach((field) => {
      field.classList.remove("has-error");
      const error = field.querySelector("[data-categories-error]");
      if (error) error.hidden = true;
    });
  }

  function showCategoryError(name) {
    const field = categoryForm?.querySelector(`[data-categories-field="${name}"]`);
    if (!field) return;
    field.classList.add("has-error");
    const error = field.querySelector("[data-categories-error]");
    if (error) error.hidden = false;
  }

  function clearPointErrors() {
    pointForm?.querySelectorAll("[data-categories-point-field]").forEach((field) => {
      field.classList.remove("has-error");
      const error = field.querySelector("[data-categories-point-error]");
      if (error) error.hidden = true;
    });
  }

  function showPointError(name) {
    const field = pointForm?.querySelector(`[data-categories-point-field="${name}"]`);
    if (!field) return;
    field.classList.add("has-error");
    const error = field.querySelector("[data-categories-point-error]");
    if (error) error.hidden = false;
  }

  function emptyDraft() {
    return {
      id: store.createId(),
      key: "",
      slug: "",
      title: "",
      titleHtml: "",
      subtitle: "",
      image: "",
      overviewImage: "",
      nextSlug: "",
      servicesTitle: "",
      points: [],
    };
  }

  function isDefaultCardImage(src) {
    const value = String(src || "").trim();
    if (!value) return true;
    return value === store.DEFAULT_IMAGE;
  }

  function updateCardImagePreview(src) {
    if (!cardImagePreview) return;
    const img = cardImagePreview.querySelector("img");
    if (!src) {
      cardImagePreview.hidden = true;
      if (img) img.src = "";
      return;
    }
    if (img) img.src = src;
    cardImagePreview.hidden = false;
  }

  function cloneCategory(category) {
    return {
      ...category,
      points: (category.points || []).map((item) => ({ ...item })),
    };
  }

  function fillNextSelect() {
    if (!nextSelect || !draftCategory) return;
    const others = store.getCategories().filter((item) => item.id !== draftCategory.id);
    const options = [
      '<option value="">Следующая в списке</option>',
      ...others.map((item) => (
        `<option value="${store.escapeHtml(item.slug)}">${store.escapeHtml(item.title)}</option>`
      )),
    ];
    nextSelect.innerHTML = options.join("");
    nextSelect.value = draftCategory.nextSlug || "";
    if (draftCategory.nextSlug && nextSelect.value !== draftCategory.nextSlug) {
      nextSelect.value = "";
    }
  }

  function closePointModal() {
    if (pointModal) pointModal.hidden = true;
    document.body.classList.remove("is-admin-modal-open");
    editingPointId = null;
    if (pointForm) pointForm.reset();
    clearPointErrors();
  }

  function openPointModal(pointId) {
    if (!pointForm || !draftCategory) return;
    if (!String(categoryForm?.elements.title.value || "").trim()) {
      showCategoryError("title");
      return;
    }

    const point = pointId
      ? draftCategory.points.find((item) => item.id === pointId)
      : null;
    editingPointId = point ? point.id : null;

    pointForm.elements.name.value = point?.name || "";
    if (pointFormTitle) {
      pointFormTitle.textContent = point ? "Изменить подпункт" : "Новый подпункт";
    }
    clearPointErrors();
    if (pointModal) pointModal.hidden = false;
    document.body.classList.add("is-admin-modal-open");
  }

  function renderPointsAdmin() {
    if (!pointsList || !draftCategory) return;
    const items = draftCategory.points || [];
    if (!items.length) {
      pointsList.innerHTML = `
        <div class="admin-panel__points-empty">
          <p class="admin-panel__points-empty-title">Подпунктов пока нет</p>
          <p class="admin-panel__hint p3">Добавьте пункты списка услуг для страницы категории</p>
        </div>
      `;
      return;
    }

    pointsList.innerHTML = items.map((point, index) => `
      <article class="admin-panel__point-card">
        <span class="admin-panel__point-card-index">${String(index + 1).padStart(2, "0")}</span>
        <p class="admin-panel__point-card-text">${store.escapeHtml(point.name)}</p>
        <div class="admin-panel__point-card-actions">
          <button class="admin-panel__action-btn" type="button" data-categories-point-edit="${store.escapeHtml(point.id)}">Изменить</button>
          <button class="admin-panel__action-btn admin-panel__action-btn_danger" type="button" data-categories-point-delete="${store.escapeHtml(point.id)}">Удалить</button>
        </div>
      </article>
    `).join("");
  }

  function fillItemForm() {
    if (!categoryForm || !draftCategory) return;
    categoryForm.elements.title.value = draftCategory.title || "";
    categoryForm.elements.subtitle.value = draftCategory.subtitle || "";
    fillNextSelect();

    const cardSrc = isDefaultCardImage(draftCategory.image)
      ? ""
      : (draftCategory.image || "");
    if (cardImageData) cardImageData.value = cardSrc;
    if (cardImageInput) cardImageInput.value = "";
    updateCardImagePreview(cardSrc || store.resolveCategoryImage(draftCategory));

    const overviewSrc = isDefaultOverviewImage(draftCategory.overviewImage)
      ? ""
      : (draftCategory.overviewImage || "");
    if (overviewImageData) overviewImageData.value = overviewSrc;
    if (overviewImageInput) overviewImageInput.value = "";
    updateOverviewPreview(overviewSrc);

    if (itemPageTitle) {
      itemPageTitle.innerHTML = draftCategory.title
        ? `<span>${store.escapeHtml(draftCategory.title)}</span>`
        : "<span>Новая категория</span>";
    }
    if (itemPreviewLink) {
      if (draftCategory.slug) {
        itemPreviewLink.href = store.getServicePath(draftCategory);
        itemPreviewLink.hidden = false;
      } else {
        itemPreviewLink.href = "/services";
      }
    }
    if (categoryDeleteBtn) {
      categoryDeleteBtn.hidden = !store.getCategories().some((item) => item.id === draftCategory.id);
    }
    if (itemNote) itemNote.hidden = true;
    clearCategoryErrors();
    closePointModal();
    renderPointsAdmin();
  }

  function showItemEditor(categoryId) {
    hideOtherEditors();
    if (categoriesEditor) categoriesEditor.hidden = true;
    if (categoriesItemEditor) categoriesItemEditor.hidden = false;

    const existing = categoryId
      ? store.getCategories().find((item) => item.id === categoryId || item.key === categoryId)
      : null;

    draftCategory = existing ? cloneCategory(existing) : emptyDraft();
    fillItemForm();
  }

  function renderCategoriesAdmin() {
    const categories = store.getCategories();
    if (categoriesCount) categoriesCount.textContent = `Категорий: ${categories.length}`;
    if (!categoriesList) return;

    if (!categories.length) {
      categoriesList.innerHTML = `
        <div class="admin-panel__categories-empty">
          <p class="admin-panel__categories-empty-title">Пока нет категорий</p>
          <p class="admin-panel__hint p3">Создайте первую категорию для портфолио и услуг</p>
        </div>
      `;
      return;
    }

    const portfolio = window.NMPortfolioContent?.getPortfolioData?.();
    const services = window.NMServicesContent?.getServices?.() || [];

    categoriesList.innerHTML = categories.map((category) => {
      const projectsCount = portfolio?.projects?.filter((item) => item.category === category.key).length || 0;
      const servicesCount = services.filter((item) => item.categoryKey === category.key).length;
      const pointsCount = (category.points || []).length;
      const hasCustomPhoto = Boolean(
        category.overviewImage
        && category.overviewImage !== store.DEFAULT_OVERVIEW_IMAGE,
      );
      const hasCustomIcon = Boolean(
        category.image
        && category.image !== store.DEFAULT_IMAGE,
      );
      const subtitle = String(category.subtitle || "").trim();
      const cardImage = store.resolveCategoryImage(category);
      return `
        <article class="admin-panel__category-card">
          <div class="admin-panel__leader-photo admin-panel__category-card-photo">
            <img src="${store.escapeHtml(cardImage)}" alt="" width="72" height="72" />
          </div>
          <div class="admin-panel__category-card-body">
            <h4 class="admin-panel__category-card-title">${store.escapeHtml(category.title)}</h4>
            ${subtitle ? `<p class="admin-panel__category-card-desc">${store.escapeHtml(subtitle)}</p>` : ""}
            <div class="admin-panel__category-card-tags">
              <span class="admin-panel__category-stat">Проектов: ${projectsCount}</span>
              <span class="admin-panel__category-stat">Услуг: ${servicesCount}</span>
              <span class="admin-panel__category-stat">Подпунктов: ${pointsCount}</span>
              ${hasCustomIcon ? '<span class="admin-panel__category-stat admin-panel__category-stat_photo">Есть иконка</span>' : ""}
              ${hasCustomPhoto ? '<span class="admin-panel__category-stat admin-panel__category-stat_photo">Есть фото рекомендации</span>' : ""}
            </div>
          </div>
          <div class="admin-panel__category-card-actions">
            <button class="admin-panel__action-btn" type="button" data-categories-open="${store.escapeHtml(category.id)}">Настроить</button>
            <button class="admin-panel__action-btn admin-panel__action-btn_danger" type="button" data-categories-remove="${store.escapeHtml(category.id)}">Удалить</button>
          </div>
        </article>
      `;
    }).join("");
  }

  function showCategoriesEditor() {
    hideOtherEditors();
    if (categoriesItemEditor) categoriesItemEditor.hidden = true;
    if (categoriesEditor) categoriesEditor.hidden = false;
    draftCategory = null;
    closePointModal();
    renderCategoriesAdmin();
  }

  function persistDraft() {
    if (!draftCategory || !categoryForm) return null;
    clearCategoryErrors();

    const title = String(categoryForm.elements.title.value || "").trim();
    const subtitle = String(categoryForm.elements.subtitle.value || "").trim();
    if (!title) {
      showCategoryError("title");
      return null;
    }

    draftCategory.title = title;
    draftCategory.titleHtml = store.buildTitleHtml(title);
    draftCategory.subtitle = subtitle;
    draftCategory.nextSlug = String(categoryForm.elements.nextSlug.value || "").trim();
    draftCategory.image = String(cardImageData?.value || "").trim() || store.DEFAULT_IMAGE;
    draftCategory.overviewImage = String(overviewImageData?.value || "").trim();
    draftCategory.servicesTitle = `Услуги ${title.toLowerCase()}:`;
    if (!draftCategory.slug) {
      draftCategory.slug = store.uniqueSlug(
        store.slugify(title),
        draftCategory.id,
        store.getCategories(),
      );
    }
    if (!draftCategory.key) {
      draftCategory.key = store.uniqueKey(
        draftCategory.slug,
        draftCategory.id,
        store.getCategories(),
      );
    }

    const saved = store.upsertCategory(draftCategory);
    const next = saved?.categories.find((item) => item.id === draftCategory.id);
    if (next) draftCategory = cloneCategory(next);
    window.NMServicesContent?.hydratePublicServices?.();
    window.NMPortfolioContent?.hydratePortfolio?.();
    return draftCategory;
  }

  function handleCategorySubmit(event) {
    event.preventDefault();
    if (!persistDraft()) return;
    fillItemForm();
    if (itemNote) itemNote.hidden = false;
    renderCategoriesAdmin();
  }

  function handlePointSubmit(event) {
    event.preventDefault();
    if (!draftCategory || !pointForm) return;
    clearPointErrors();

    const name = String(pointForm.elements.name.value || "").trim();
    if (!name) {
      showPointError("name");
      return;
    }

    const nextPoint = {
      id: editingPointId || store.createId(),
      name,
    };
    const index = draftCategory.points.findIndex((item) => item.id === nextPoint.id);
    if (index >= 0) {
      draftCategory.points[index] = nextPoint;
    } else {
      draftCategory.points.push(nextPoint);
    }

    if (!persistDraft()) return;
    closePointModal();
    renderPointsAdmin();
    renderCategoriesAdmin();
  }

  function removeCategory(id) {
    const category = store.getCategories().find((item) => item.id === id || item.key === id);
    if (!category) return;
    if (store.getCategories().length <= 1) {
      window.alert("Нельзя удалить последнюю категорию."); // eslint-disable-line no-alert
      return;
    }
    // eslint-disable-next-line no-alert
    if (!window.confirm(`Удалить категорию «${category.title}»? Связанные проекты и услуги будут перенесены.`)) return;
    const fallback = store.getCategories().find((item) => item.id !== category.id);
    store.deleteCategory(category.id, { fallbackKey: fallback?.key });
    window.NMServicesContent?.hydratePublicServices?.();
    window.NMPortfolioContent?.hydratePortfolio?.();
  }

  document.querySelectorAll('[data-content-open="categories"]').forEach((button) => {
    button.addEventListener("click", showCategoriesEditor);
  });

  categoryCreateBtn?.addEventListener("click", () => showItemEditor(null));
  itemBackBtn?.addEventListener("click", showCategoriesEditor);
  categoryForm?.addEventListener("submit", handleCategorySubmit);
  pointForm?.addEventListener("submit", handlePointSubmit);
  pointCreateBtn?.addEventListener("click", () => openPointModal(null));

  document.querySelectorAll("[data-categories-point-modal-close]").forEach((el) => {
    el.addEventListener("click", closePointModal);
  });

  if (overviewImageInput) {
    overviewImageInput.addEventListener("change", () => {
      const file = overviewImageInput.files?.[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = () => {
        const result = String(reader.result || "");
        if (overviewImageData) overviewImageData.value = result;
        updateOverviewPreview(result);
      };
      reader.readAsDataURL(file);
    });
  }

  overviewImageReset?.addEventListener("click", () => {
    if (overviewImageData) overviewImageData.value = "";
    if (overviewImageInput) overviewImageInput.value = "";
    updateOverviewPreview("");
  });

  if (cardImageInput) {
    cardImageInput.addEventListener("change", () => {
      const file = cardImageInput.files?.[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = () => {
        const result = String(reader.result || "");
        if (cardImageData) cardImageData.value = result;
        updateCardImagePreview(result);
      };
      reader.readAsDataURL(file);
    });
  }

  cardImageReset?.addEventListener("click", () => {
    if (cardImageData) cardImageData.value = "";
    if (cardImageInput) cardImageInput.value = "";
    updateCardImagePreview(store.DEFAULT_IMAGE);
  });

  categoryDeleteBtn?.addEventListener("click", () => {
    if (!draftCategory) return;
    removeCategory(draftCategory.id);
    showCategoriesEditor();
  });

  categoriesList?.addEventListener("click", (event) => {
    const openBtn = event.target.closest("[data-categories-open]");
    const removeBtn = event.target.closest("[data-categories-remove]");
    if (openBtn) showItemEditor(openBtn.getAttribute("data-categories-open"));
    if (removeBtn) {
      removeCategory(removeBtn.getAttribute("data-categories-remove"));
      renderCategoriesAdmin();
    }
  });

  pointsList?.addEventListener("click", (event) => {
    const editBtn = event.target.closest("[data-categories-point-edit]");
    const deleteBtn = event.target.closest("[data-categories-point-delete]");
    if (editBtn) openPointModal(editBtn.getAttribute("data-categories-point-edit"));
    if (deleteBtn && draftCategory) {
      const id = deleteBtn.getAttribute("data-categories-point-delete");
      draftCategory.points = draftCategory.points.filter((item) => item.id !== id);
      persistDraft();
      if (editingPointId === id) closePointModal();
      renderPointsAdmin();
      renderCategoriesAdmin();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    if (pointModal && !pointModal.hidden) closePointModal();
  });

  window.NMAdminCategoriesContent = {
    showCategoriesEditor,
    showItemEditor,
    closePointModal,
    renderCategoriesAdmin,
  };
}

if (adminRoot) {
  initAdminCategoriesContent();
  window.setTimeout(initAdminCategoriesContent, 0);
}
